import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import ActionButton from '@/components/action_button/Index.vue';
import PageSubscribe from '@/plugins/graphql/mutations/page-subscribe.gql';
import AppBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import { Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
/**
 * Page List Item Component
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since v0.0.1
 */
let PageListItem = class PageListItem extends mixins(RouteParamsAppMixin, GraphqlErrorMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        /**
         * Activate Button Loader
         */
        this.toggleLoader = false;
    }
    async connect(page) {
        /**
         * Trigger Mutation for connecting Page into Messenger Bot
         * @type { Page }
         */
        this.toggleLoader = !this.toggleLoader;
        const mutation = this.pageSubscribe(page);
        await mutation
            .then(() => {
            const delay = 3000;
            setTimeout(() => {
                this.toggleLoader = !this.toggleLoader;
                this.$store.commit('setAppActivePage', page);
            }, delay);
            this.clearPersistentErrorNotification();
        })
            .catch((error) => {
            this.toggleLoader = !this.toggleLoader;
            this.errorNotification(error.message);
            this.logError(error.message);
        });
    }
    appBasicQuery() {
        return {
            query: AppBasic,
            variables: {
                appUuid: this.appUUID,
            },
        };
    }
    pageSubscribe(page) {
        const vm = this;
        return this.$apollo.mutate({
            mutation: PageSubscribe,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    accessToken: page.access_token,
                    fbPageId: page.id,
                    pageName: page.name,
                    photoUrl: page.picture.data.url,
                },
            },
            // To Update Persistent Mini App Status to Active
            refetchQueries: [vm.appBasicQuery()],
        });
    }
};
__decorate([
    Prop({ required: true })
], PageListItem.prototype, "page", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PageListItem.prototype, "active", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PageListItem.prototype, "alreadyConnected", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], PageListItem.prototype, "showConfirmationDialog", void 0);
PageListItem = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], PageListItem);
export default PageListItem;
